/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BrokerEmailTargetEnum;

(function (BrokerEmailTargetEnum) {
  BrokerEmailTargetEnum["BOTH"] = "both";
  BrokerEmailTargetEnum["CUSTOMER"] = "customer";
  BrokerEmailTargetEnum["BROKER"] = "broker";
})(BrokerEmailTargetEnum || (BrokerEmailTargetEnum = {}));